import React from "react";
import { useConnectionState } from "@/zustand/ConnectionState";
import { WifiOff } from "lucide-react";

import { useTranslation } from "react-i18next";

export const NetworkStatusIndicator: React.FC = () => {
  const { t } = useTranslation();
  const networkStatus = useConnectionState((state) => state.networkStatus);

  if (networkStatus === "online") {
    return null;
  }

  return (
    <div className="fixed left-0 top-0 z-50 flex w-full items-center justify-center bg-red-500 pt-[env(safe-area-inset-top,0px)] text-xs font-medium text-white">
      <div className="flex items-center gap-1">
        <WifiOff className="size-3" />
        <span>{t("connectionLost")}</span>
      </div>
    </div>
  );
};
